import {
    Component,
    Input,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { getIconName } from '@masar/common/utils';

@Component({
    selector: 'app-file-icon',
    template: `<div
        class="mx-auto flex items-center justify-center"
        style="width: 50px; height: 50px"
    >
        <img
            [src]="'/assets/img/file-icon/' + icon + '.svg'"
            [alt]="icon + ' file'"
            class="h-full w-full object-contain"
        />
    </div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FileIconComponent implements OnInit {
    @Input() public contentType?: string;

    @Input() public icon?: string;

    public ngOnInit(): void {
        if (this.contentType) this.icon = getIconName(this.contentType);
    }
}
